import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const rows = [{
  without: 'You build everything from scratch each week',
  with: 'A full client journey, already mapped'
}, {
  without: 'You improvise and hope it goes well',
  with: 'A proven method, session by session'
}, {
  without: 'Clients who drop off after a month',
  with: 'Complete engagements that renew'
}, {
  without: 'You charge by the loose hour',
  with: 'You run programs clients see through to the end'
}];
export function Close() {
  return <section aria-labelledby="close-heading" className="w-full bg-white" data-id="element-36" data-mp="1c5h42juxfslb">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-37" data-mp="17abhrjxm4bwp">
        <h2 id="close-heading" className="font-serif font-black text-ink text-[30px] sm:text-5xl leading-[1.1] tracking-tight" data-id="element-38" data-mp="128cgqgpchr2x">
          Stop improvising. <span className="text-sage" data-id="element-39" data-mp="3vf57pgwil2vp">Start coaching with a system.</span>
        </h2>

        <p className="mt-5 text-ink-soft text-base sm:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-40" data-mp="40hedyma5114">
          Join the hundreds of coaches already running professional sessions —
          with a clear path, and clients who renew.
        </p>

        <p className="mt-7 font-bold text-sm sm:text-base uppercase tracking-[0.14em] text-terracotta" data-id="element-41" data-mp="3qgtxh52b4qcy">
          Sessions. Worksheets. Scripts. Follow-up. Closing. Renewal.
          <span className="block mt-1 text-ink" data-id="element-42" data-mp="mzvb2obe8pvb">All done for you.</span>
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-cream-dark shadow-card text-left" data-id="element-43" data-mp="82ufg9q30ark">
          <table className="w-full" data-id="element-44" data-mp="d0mju37wxpcn">
            <thead data-id="element-45" data-mp="czkv4vxz54cg">
              <tr data-id="element-46" data-mp="d38pfxb8tus8">
                <th className="w-1/2 bg-danger-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-danger" data-id="element-47" data-mp="2sstluerhabs2">
                  ✕ Without the System
                </th>
                <th className="w-1/2 bg-vital-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-vital" data-id="element-48" data-mp="148xsj8ku2ljv">
                  ✓ With the System
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-49" data-mp="uicnb2anmirz">
              {rows.map(row => <tr key={row.without} className="bg-white align-top" data-id="element-50" data-mp="pkjfk4tpdgpl">
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] text-ink-muted" data-id="element-51" data-mp="kkyijzy3fifi">
                    {row.without}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] font-semibold text-ink" data-id="element-52" data-mp="gik1nldzisqv">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-12 rounded-3xl bg-cream border border-cream-dark p-7 sm:p-10" data-id="element-53" data-mp="6ni88dcof4ih">
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold uppercase tracking-[0.16em] text-terracotta" data-id="element-54" data-mp="25vx8pidheuvo">
            <ClockIcon className="w-4 h-4" aria-hidden="true" data-id="element-55" data-mp="28j90z32whj6w" />
            The price closes in
          </p>
          <div className="mt-5" data-id="element-56" data-mp="2dh0t9y7gj7bm">
            <Countdown data-id="element-57" data-mp="2dg7upkinjo4k" />
          </div>
          <p className="mt-7 font-serif font-bold text-ink text-lg sm:text-2xl" data-id="element-58" data-mp="2i8iwyu0v7m0a">
            The Life Coach&apos;s Complete System —{' '}
            <span className="text-terracotta" data-id="element-59" data-mp="2n6kf9cqgvhap">$27</span>
          </p>
          <p className="mt-4 text-xs sm:text-sm text-ink-muted" data-id="element-60" data-mp="1pk3jwd1andrl">
            The product will be charged in local currency
          </p>
          <CtaButton className="mt-3 w-full sm:w-auto" data-id="element-61" data-mp="1ujpusftnghx8">
            YES, I WANT THE COMPLETE SYSTEM
          </CtaButton>
          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-62" data-mp="1zgq36xdz1wri">
            <li className="flex items-center gap-1.5" data-id="element-63" data-mp="3ax6j0rtfufew">
              <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-64" data-mp="3awofrb8cz0xh" />
              100% secure checkout
            </li>
            <li className="flex items-center gap-1.5" data-id="element-65" data-mp="3fydp8mfxn6jg">
              <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-66" data-mp="3dinqcy7l5bm1" />
              Instant access
            </li>
            <li className="flex items-center gap-1.5" data-id="element-67" data-mp="39hlqqg9raxjj">
              <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-68" data-mp="3ngbo7x0hmz8f" />
              7-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}